export const rewardTypeMessages = {
  KolorsRewardMVP: {
    id: 'loyalty.rewards.new.type.discount',
    defaultMessage: 'Discount'
  },
  KolorsGoRewardMVP: {
    id: 'loyalty.rewards.new.type.time',
    defaultMessage: 'Time'
  }
}
